import { IoIosStar } from "react-icons/io";
import thunder from "../../assets/thunder.png";
import chart from "../../assets/chart.png";
import icon from "../../assets/icon.png";
import { useTranslation } from "react-i18next";

function DataProvider() {
  // Hook
  const { t } = useTranslation();

  const providData = [
    {
      id: 1,
      img: thunder,
      header: t("dataCardOneHeading"),
      paragraph: t("dataCardOneDesc"),
    },
    {
      id: 2,
      img: chart,
      header: t("dataCardTwoHeading"),
      paragraph: t("dataCardTwoDesc"),
    },
    {
      id: 3,
      img: icon,
      header: t("dataCardThreeHeading"),
      paragraph: t("dataCardThreeDesc"),
    },
  ];

  return (
    <div className="w-full md:pt-20 pt-10 pb-20 bg-[#F9F8FE]" id="product">
      <div className="project-container md:flex md:justify-center gap-20 px-4">
        {/* Left side */}
        <div className="left md:w-6/12 md:mx-0 mx-auto">
          <h1 className="lg:text-[50px] lg:leading-[110%] md:text-4xl font-semibold text-[25px] text-center md:text-left">
            {t("dataPHeading")}
          </h1>

          <p className="text-[#A6A6A6] md:mt-8 md:mb-28 mt-4 mb-14 text-center text-sm md:text-left md:text-base">
            {t("dataPSubheading")}
          </p>

          
        </div>

        {/* Right side */}
        <div className="right md:w-6/12">
          {providData?.map(({ id, img, header, paragraph }) => (
            <div key={id} className="flex items-start gap-3 mt-5 text-left">
              <div>
                <img src={img} alt="Thunder" />
              </div>
              <div className="w-full">
                <h1 className="text-xl md:text-[27px] font-bold">{header}</h1>
                <p className="text-sm md:text-lg text-[#A6A6A6] font-medium mt-2.5">
                  {paragraph}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DataProvider;
